import React from 'react';
import { Modal, Button, Badge } from 'react-bootstrap';
import { motion, AnimatePresence } from 'framer-motion';
import HealthChecker from "./HealthChecker";
import {useNavigate} from "react-router-dom";

const HealthScoreModal = ({
                              show,
                              onHide,
                              score = 0,
                              totalQuestions = 10,
                              userName = ''
                          }) => {

    const navigate = useNavigate();
    // Determine health category and message based on score
    const getHealthStatus = (score) => {
        if (score >= 8) {
            return {
                category: 'Excellent Health',
                categoryHindi: 'उत्कृष्ट स्वास्थ्य',
                message: "You're on the right track!",
                messageHindi: 'आप सही रास्ते पर हैं!',
                color: '#28a745',
                bgColor: '#d4edda',
                borderColor: '#c3e6cb',
                range: '8-10'
            };
        } else if (score >= 6) {
            return {
                category: 'Good Health',
                categoryHindi: 'अच्छा स्वास्थ्य',
                message: 'Some areas need attention',
                messageHindi: 'कुछ क्षेत्रों में सुधार की जरूरत है',
                color: '#ffc107',
                bgColor: '#fff3cd',
                borderColor: '#ffeaa7',
                range: '6-7'
            };
        } else {
            return {
                category: 'Time for Change',
                categoryHindi: 'परिवर्तन का समय',
                message: 'Start with Anuyog to improve!',
                messageHindi: 'बेहतर स्वास्थ्य के लिए Anuyog से शुरू करें!',
                color: '#dc3545',
                bgColor: '#f8d7da',
                borderColor: '#f5c6cb',
                range: '0-5'
            };
        }
    };

    const healthStatus = getHealthStatus(score);

    const handleJoinWorkshop = () => {
        navigate('/workshop')
        onHide();
    };

    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                centered
                backdrop="static"
                keyboard={false}
                size="md"
                className="health-score-modal"
            >
                <div className="position-relative">
                    <Button
                        variant=""
                        className="position-absolute btn-close-custom"
                        onClick={onHide}
                        style={{
                            top: '20px',
                            right: '20px',
                            zIndex: 1060,
                            width: '35px',
                            height: '35px',
                            borderRadius: '50%',
                            backgroundColor: '#dc3545',
                            border: 'none',
                            color: 'white',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 8px rgba(220, 53, 69, 0.3)',
                            marginTop: '0'
                        }}
                    >
                        ×
                    </Button>

                    <Modal.Body className="text-center px-4 py-4 pt-5">
                        <AnimatePresence>
                            {show && (
                                <motion.div
                                    initial={{ opacity: 0, scale: 0.8 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0, scale: 0.8 }}
                                    transition={{ type: "spring", damping: 20, stiffness: 300 }}
                                >
                                    {/* Modal Title */}
                                    <motion.h4
                                        className="text-success fw-bold mb-4"
                                        initial={{ opacity: 0, y: -20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: 0.2 }}
                                        style={{ marginTop: '10px' }}
                                    >
                                        Your Health Score / आपका स्वास्थ्य स्कोर
                                    </motion.h4>

                                    {/* Score Display */}
                                    <motion.div
                                        initial={{ scale: 0 }}
                                        animate={{ scale: 1 }}
                                        transition={{ delay: 0.3, type: "spring", damping: 15 }}
                                        className="mb-4"
                                        style={{
                                            background: 'linear-gradient(135deg, #f8fffe 0%, #f0f9f5 100%)',
                                            padding: '30px 20px',
                                            borderRadius: '16px',
                                            border: '1px solid #e1f5e9'
                                        }}
                                    >
                                        <div
                                            className="display-1 fw-bold mb-3"
                                            style={{
                                                color: healthStatus.color,
                                                fontSize: '4.5rem',
                                                textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                        >
                                            {score}/{totalQuestions}
                                        </div>

                                        {/*<Badge*/}
                                        {/*    bg=""*/}
                                        {/*    className="px-3 py-2 fs-6 fw-bold"*/}
                                        {/*    style={{*/}
                                        {/*        backgroundColor: healthStatus.color,*/}
                                        {/*        fontSize: '14px'*/}
                                        {/*    }}*/}
                                        {/*>*/}
                                        {/*    ✅ {healthStatus.range}*/}
                                        {/*</Badge>*/}
                                    </motion.div>

                                    {/* Health Status Message */}
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: 0.5 }}
                                        className="mb-4"
                                    >
                                        <div
                                            className="p-4 rounded-3 mb-3"
                                            style={{
                                                backgroundColor: healthStatus.bgColor,
                                                border: `1px solid ${healthStatus.borderColor}`,
                                                color: healthStatus.color === '#ffc107' ? '#856404' : healthStatus.color
                                            }}
                                        >
                                            <h5 className="fw-bold mb-2">
                                                {/*✅ {healthStatus.range} YES: */}
                                                {healthStatus.category} – {healthStatus.message}
                                            </h5>
                                            <p className="mb-0 fst-italic" style={{ fontSize: '14px', opacity: 0.8 }}>
                                                {healthStatus.categoryHindi} – {healthStatus.messageHindi}
                                            </p>
                                        </div>
                                    </motion.div>

                                    {/* Improvement Message (only for scores below 8) */}
                                    {score < 8 && (
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ delay: 0.7 }}
                                            className="mb-4"
                                        >
                                            <div className="d-flex align-items-start gap-3 p-3 bg-light rounded-3">
                                                <span style={{ fontSize: '24px' }}>🌱</span>
                                                <div className="text-start">
                                                    <p className="fw-semibold mb-1">
                                                        Want to improve your score? Start your natural health journey with Anuyog today!
                                                    </p>
                                                    <small className="text-muted fst-italic">
                                                        "स्वास्थ्य सुधारना चाहते हैं? आज ही Anuyog के साथ अपनी प्राकृतिक स्वास्थ्य यात्रा शुरू करें।"
                                                    </small>
                                                </div>
                                            </div>
                                        </motion.div>
                                    )}

                                    {/* Action Button */}
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: 0.9 }}
                                    >
                                        <motion.div
                                            whileHover={{ scale: 1.05 }}
                                            whileTap={{ scale: 0.95 }}
                                        >
                                            <Button
                                                size="lg"
                                                className="px-5 py-3 fw-bold rounded-pill"
                                                style={{
                                                    background: 'linear-gradient(135deg, #51cf66 0%, #40c057 100%)',
                                                    border: 'none',
                                                    boxShadow: '0 4px 15px rgba(64, 192, 87, 0.3)',
                                                    fontSize: '16px',
                                                    minWidth: '250px'
                                                }}
                                                onClick={handleJoinWorkshop}
                                            >
                                                Join Anuyog Workshop
                                            </Button>
                                        </motion.div>
                                    </motion.div>

                                    {/* Thank you message for high scores */}
                                    {score >= 8 && (
                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 1.1 }}
                                            className="mt-3"
                                        >
                                            <small className="text-success fw-semibold">
                                                🎉 Congratulations on maintaining excellent health! Keep up the great work!
                                            </small>
                                        </motion.div>
                                    )}
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </Modal.Body>
                </div>
            </Modal>

            {/* Custom CSS for additional styling */}
            <style jsx global>{`
                .health-score-modal .modal-content {
                    border: none;
                    border-radius: 20px;
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
                    overflow: hidden;
                }

                .health-score-modal .modal-body {
                    padding: 1.5rem 2rem 2rem 2rem;
                }

                .btn-close-custom:hover {
                    background-color: #bb2d3b !important;
                    transform: scale(1.1);
                }

                .btn-close-custom:active {
                    transform: scale(0.95);
                }

                @media (max-width: 768px) {
                    .health-score-modal .modal-body {
                        padding: 1.5rem 1.5rem 1.5rem 1.5rem;
                    }

                    .btn-close-custom {
                        top: 15px !important;
                        right: 15px !important;
                        width: 30px !important;
                        height: 30px !important;
                        fontSize: 16px !important;
                    }

                    .health-score-modal .display-1 {
                        font-size: 3.5rem !important;
                    }

                    .health-score-modal .btn-lg {
                        min-width: 200px !important;
                        padding: 12px 24px !important;
                        font-size: 15px !important;
                    }
                }

                @media (max-width: 480px) {
                    .health-score-modal .display-1 {
                        font-size: 2.8rem !important;
                    }
                }
            `}</style>
        </>
    );
};

export default HealthScoreModal;